let versionHash = null

export default async function checkForVersionUpdate(isCallActive) {
  try {
    const response = await fetch(window.location.origin)
    const text = await response.text()
    const indexHashPosition = text.indexOf('/js/index')
    const indexHash = text.substring(indexHashPosition + 9, text.indexOf('.js', indexHashPosition))
    if (versionHash === null) {
      versionHash = indexHash
    } else if (
      !isCallActive
      && versionHash !== indexHash
    ) {
      window.location.reload()
    }
  } catch (error) {
    console.log(error)
  }
}
